<template>
  <div v-if="event != null">
    <template v-if="show">
      <div class="description">
        <div class="content-information">
          <div class="icon">
            <img class="img-icon" :src="images.find(image => image[event.event_type])[event.event_type]" alt="">
          </div>
          <div class="content">
            <p class="description-title">{{event.name_key}}</p>
            <p class="description-content" v-if="event.status_event == 'in_progress'">{{event.translate_text_description_in_progress}}</p>        
            <template v-if="event.status_event == 'finished'">
              <p class="description-content-download" v-if="event.text_description_finished == 'project_finished_finished'" @click.prevent="linkToReport">{{event.translate_text_description_finished}}</p>
              <p class="description-content" v-else>{{event.translate_text_description_finished}}</p>              
            </template>            
            <div class="details">
              <div class="event-date">
                <EventDate :date="event.created_at" />
              </div>
              <div class="show-details" v-if="showDetails" @click.prevent="actionShowModal">
                Ver detalles
              </div>                  
            </div>
          </div>              
        </div>      
      </div>
      <div class="rectangle"></div>      
    </template>
    <div class="description-hide" v-else></div>
    <EventModal :event="event" v-if="showModal"/>
  </div>    
</template>

<script>
  import { eventBus } from './../../application'
  import EventModal from './EventModal.vue'
  import EventDate from './EventDate.vue'
  export default {
    props: {
      project: Object,
      event: null,
      show: null
    },
    data() {
      return {
        loading: false,
        showModal: false, 
        showDetails: this.checkShowDetails(),
        images: [
          {
            'request_process': 'https://res.cloudinary.com/dhcti0lrk/image/upload/v1613489628/globalwork/steps/step_1_nivjti.png'
          },
          {
            'information_completed': 'https://res.cloudinary.com/dhcti0lrk/image/upload/v1613505331/globalwork/steps/folder_1_lwer9h.png'
          },
          {
            'request_validations': 'https://res.cloudinary.com/dhcti0lrk/image/upload/v1613505087/globalwork/steps/Solicitud_de_verificaciones_lbufjx.png'
          },
          {
            'verifications_response': 'https://res.cloudinary.com/dhcti0lrk/image/upload/v1613505087/globalwork/steps/Respuestas_de_verificaciones_ipefkf.png'
          },
          {
            'project_finished': 'https://res.cloudinary.com/dhcti0lrk/image/upload/v1613505087/globalwork/steps/Cierre_y_resultados_del_proceso_qtpd3q.png'
          }          
        ],
        texts: [
          {
            'request_process': 'Estamos solicitando la información de identificación del candidato.'
          },
          {
            'information_completed': 'Hemos recibido la información completa del candidato para poder iniciar con la validación.'
          },
          {
            'request_validations': 'Se están realizando las respectivas verificaciones del candidato.'
          },
          {
            'verifications_response': 'Hemos recibido los resultados de las verificaciones del candidato.'
          },
          {
            'project_finished': 'Estamos revisando la información y garantizando que los datos arrojados son correctos.'
          }          
        ], 
      }
    },
    methods: {
      checkShowDetails () {
        let result = false
        let show_for_childrens = false
        if (this.event.childrens.length > 0) {
          show_for_childrens = true
        }
        let show_for_rules = false
        if (this.event.event_type == 'information_completed'){
          if (this.event.rules_incompleted_step_information_completed.documents.length > 0) {
            show_for_rules = true
          }
          if (this.event.rules_incompleted_step_information_completed.references.length > 0) {
            show_for_rules = true
          }          
        }
        if (this.event.event_type == 'request_validations'){
          if (this.event.rules_incompleted_step_request_validations.length > 0) {
            show_for_rules = true
          }
        }
        if (this.event.event_type == 'verifications_response'){
          if (this.event.rules_incompleted_step_verifications_response.length > 0) {
            show_for_rules = true
          }
        }
        if (show_for_childrens || show_for_rules) {
          result = true          
          eventBus.$emit('hideContentVisible')
        }
        return result
      },
      actionShowModal() {
        if (this.checkShowDetails()) {
          this.showModal = true
          eventBus.$emit('hideContentVisible')
        }
      }                  
    },
    components: {
      EventModal,
      EventDate
    },
    mounted () {
      eventBus.$on('hideModal', dataPassed => {
        this.showModal = false
      })      
      eventBus.$on('actionShowModal', event => {
        if (event.childrens.length > 0) this.actionShowModal()
      })            
    },
  }
</script>

<style scoped>

</style>
